export default "__VITE_ASSET__W4gG1bZf__"